const DEFAULT_APP_NAME = "PalletExchange"
const APP_NAME_TOKEN = "{{APP_NAME}}"

export const APP_NAME = (process.env.NEXT_PUBLIC_APP_NAME || "").trim() || DEFAULT_APP_NAME

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value)
}

const replaceAppNameInString = (value: string): string => {
    if (!value.includes(DEFAULT_APP_NAME) && !value.includes(APP_NAME_TOKEN)) return value
    return value
        .split(DEFAULT_APP_NAME).join(APP_NAME)
        .split(APP_NAME_TOKEN).join(APP_NAME)
}

export function replaceAppNameInContent<T>(value: T): T {
    if (typeof value === "string") {
        return replaceAppNameInString(value) as T
    }

    if (Array.isArray(value)) {
        return value.map((item) => replaceAppNameInContent(item)) as T
    }

    if (isPlainObject(value)) {
        const output: Record<string, unknown> = {}
        for (const [key, nestedValue] of Object.entries(value)) {
            output[key] = replaceAppNameInContent(nestedValue)
        }
        return output as T
    }

    return value
}
